import React, { useState, useEffect } from "react";
import { InputGroup, Input } from "reactstrap";
import DatePicker from "react-datepicker";
import { Portal } from "react-overlays";
import moment from "moment";
import ReactInputMask from "react-input-mask";

// const CalendarContainer = ({ children }) => {
//   const el = document.getElementById("calendar-portal");
//   return <Portal container={el}>{children}</Portal>;
// };

const ColumnFilters = (props) => {
  const { col, onColumnFilterChange, reset } = props;
  const [filterValue, setFilterValue] = useState();
  const [filterType, setFilterType] = useState("");

  useEffect(() => {
    setFilterValue("");
    setFilterType("");
  }, [reset]);

  const handleInputChange = (e, col, type) => {
    setFilterValue(e.target.value);
    onColumnFilterChange(e, col, type,filterType);
  };
const handleDateChangeRaw = (e) => {
    debugger;
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && filterValue !== null) {
     setFilterValue(null);
    }
    if (isValid) {
      handleDateChange(e.target.value);
    }
    else{
      const event = { target: { value: 'Invalid date' } };
      onColumnFilterChange(event, col, "field",filterType);
    }
  };
  const handleDateChange = (date) => {
    const formatDate = moment(date).format("MM/DD/YYYY");
    setFilterValue(date);
    const event = { target: { value: formatDate } };
    onColumnFilterChange(event, col, "field",filterType);
  };

  const handleSelectChange = (e, col, type) => {
    debugger
    setFilterType(e.target.value);
    onColumnFilterChange(e, col, type, e.target.value);
  };
 
  const renderInput = () => {
    if (col.inputType === "date") {
      return (
        <DatePicker
          selected={filterValue}
          onChange={handleDateChange}
          portalId="root portal"
           customInput={
                                      <ReactInputMask
                                        mask="99/99/9999"
                                        // minDate={new Date(orderDate)}
                                        value={filterValue}
                                      // maskChar=''
                                      />
                                    }
                                    
                                    onChangeRaw={handleDateChangeRaw}
          // popperContainer={CalendarContainer}
          className="border-0 w-100 date-picker-filter"
          placeholderText="MM/DD/YYYY"
        />
      );
    }

    const selectOptionsConfig = {
  poType: [
    { label: "--Select--", value: "" },
    { label: "Split", value: "split" },
    { label: "Non-Split", value: "non-split" },
    { label: "Manual Non-Split", value: "manual non-split" }
  ],
  accountType: [
    { label: "--Select--", value: "" },
    { label: "340B", value: "1001" },
    { label: "GPO", value: "1002" },
    { label: "WAC", value: "1003" },
  ],
  accountInactiveFlag: [
    { label: "--Select--", value: "" },
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ],
  status :[
    { label: "--Select--", value: "" },
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
    { label: "WillBeActive", value: "WillBeActive" }, 
  ],
  pfReviewFlag:[
    { label: "--Select--", value: "" },
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
  centralReplenishment:[
    { label: "--Select--", value: "" },
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
  ],

  inactiveFlag: [
    { label: "--Select--", value: "" },
    { label: "Active", value: "N" },
    { label: "Inactive", value: "Y" },
  ],
    isInPatient: [
    { label: "--Select--", value: "" },
    { label: "IN", value: "Y" },
    { label: "OUT", value: "N" },
  ],

   controlledSubstance: [
    { label: "--Select--", value: "" },
    { label: "C2", value: "3" },
    { label: "C3", value: "4" },
    { label: "C4", value: "5" },
    { label: "C5", value: "6" },
  ],
};

const columnOptionMapping = {
  poType: "poType",
  potype: "poType",
  accountTypeName: "accountType",
  accountType: "accountType", 
  accountInactiveFlag: "accountInactiveFlag",
  status: "status",
  accounType: "accountType",
  pfReviewFlag: "pfReviewFlag",
  suppressPOPrefix: "pfReviewFlag",
  centralReplenishment: "centralReplenishment",
  isMixedUseArea: "pfReviewFlag",
  inactiveFlag: "inactiveFlag",
  patientType1: "patientType1",
  isInPatient: "isInPatient",
  payorBlock: "centralReplenishment",
  inActiveFlag: "inactiveFlag",
  controlledSubstance: "controlledSubstance"
};

const mappedKey = columnOptionMapping[col.dataField];
const options = mappedKey ? selectOptionsConfig[mappedKey] : null;

if (options) {
  return (
    <select
      value={filterValue}
      className="dropdown-class"
      onChange={(e) => handleInputChange(e, col, "field")}
      style={{ width: "100%" ,borderRadius:"4px",background:"transparent"}}
    >

      {options
  .filter((option) => {
    if (col.screenName === "NewAuditScreen") {
      return option.label !== "WAC";
    }
    return true;
  })
  .map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
))}

    {col.screenName === "UtilizationReport" && (
      <>
        <option key={col.pendingAccountTypeId} value={col.pendingAccountTypeId}>Pending</option>
      </>
    )}
    </select>
  );
}

  
    return (
      <Input
        type={col.inputType === "number" ? "text" : col.inputType}
        placeholder={col.text}
        value={filterValue}
        onChange={(e) => handleInputChange(e, col, "field")}
      />
    );
  };

  const equalsArray = ['chargeAutomappingFlag','isMixedUseArea','isInPatient','payorBlock'];
  const decimalFieldArray = ['totalOrderedPrice','totalInvoicedPrice','packageWACPrice','packageGPOPrice','package340BPrice','pendingCount'];

   const getOptions = () => {
    if(equalsArray.includes(col.dataField)){
      return (
          <>
            <option value={1}>Equals to</option>
          </>
        );
    }
    else if(decimalFieldArray.includes(col.dataField)){
      return (
          <>
            <option value={1}>Equals to</option>
            <option value={6}>Less than or equals to</option>
            <option value={7}>Greater than or equals to</option>
          </>
        );
    }
    else{
      return (
          <>
            <option value={1}>Equals to</option>
            {col.inputType === 'text' && <option value={3}>Contains</option>}
            {col.inputType === 'text' && <option value={4}>Starts with</option>}
            {col.inputType === 'text' && <option value={5}>Ends with</option>}
            {(col.inputType === 'number' || col.inputType === 'date') && (
              <option value={6}>Less than or equals to</option>
            )}
            {(col.inputType === 'number' || col.inputType === 'date') && (
              <option value={7}>Greater than or equals to</option>
            )}
          </>
        );
    }
  }
// const getOptions = () => {
//   return (
//     <>
//       <option value={1}>Equals to</option>
//       {col.inputType === "text" && <option value={3}>Contains</option>}
//       {col.inputType === "text" && <option value={4}>Starts with</option>}
//       {col.inputType === "text" && <option value={5}>Ends with</option>}
//       {(col.inputType === "number" || col.inputType === "date") && (
//         <option value={6}>Less than or equals to</option>
//       )}
//       {(col.inputType === "number" || col.inputType === "date") && (
//         <option value={7}>Greater than or equals to</option>
//       )}
//     </>
//   );
// };
  
const dropDownColumnsArray = ['poType', 'accountType', 'accountInactiveFlag','accountTypeName','status','accounType','potype','pfReviewFlag','suppressPOPrefix','centralReplenishment','isMixedUseArea','inactiveFlag','isInPatient','payorBlock','inActiveFlag','controlledSubstance']
  return (
    <InputGroup className="table-filter-group">
    {renderInput()}
    {!dropDownColumnsArray.includes(col.dataField) && (
    <div style={{ zIndex: 0 }}>
      <Input
        type="select"
        className="table-filter-icon cursor-pointer"
        value={filterType}
        onChange={(e) => handleSelectChange(e, col, "select")}
      >
        {getOptions()}
      </Input>
    </div>
    )}
  </InputGroup>
  );
};

export default ColumnFilters;
